// import React, { useState, useEffect, useCallback } from 'react';
// import { AuthContext, transformUserData } from '../contexts/AuthContext';

// // ============================================================
// // API Base URL Configuration
// // ============================================================
// const getApiBaseUrl = () => {
//     const hostname = window.location.hostname;
    
//     // Development - localhost
//     if (hostname === 'localhost' || hostname === '127.0.0.1') {
//         return 'http://localhost:8000';
//     }
    
//     // Development - lvh.me
//     if (hostname === 'lvh.me' || hostname === 'www.lvh.me') {
//         return 'http://lvh.me:8000';
//     }
    
//     // Production - Main site (azoemart.com)
//     if (hostname === 'azoemart.com' || hostname === 'www.azoemart.com') {
//         return 'https://api.azoemart.com';
//     }
    
//     // Production - Agent subdomains (agent1.azoeshop.store)
//     if (hostname.endsWith('.azoeshop.store')) {
//         return 'https://api.azoemart.com';
//     }
    
//     // Fallback
//     return 'https://api.azoemart.com';
// };

// // ============================================================
// // Subdomain Detection Helper
// // ============================================================
// const getCurrentSubdomain = () => {
//     const hostname = window.location.hostname;
    
//     // Development - lvh.me subdomains
//     if (hostname.endsWith('.lvh.me')) {
//         return hostname.replace('.lvh.me', '');
//     }
    
//     // Production - *.azoeshop.store (Agent Sites)
//     if (hostname.endsWith('.azoeshop.store')) {
//         return hostname.replace('.azoeshop.store', '');
//     }
    
//     // No subdomain (main site)
//     return null;
// };

// // ============================================================
// // Auth Provider
// // ============================================================
// export const API_BASE_URL = getApiBaseUrl();
// console.log(`🔵 API_BASE_URL: ${API_BASE_URL}`);
// console.log(`🔵 Current subdomain: ${getCurrentSubdomain() || 'none'}`);

// export const AuthProvider = ({ children }) => {
//     const [user, setUser] = useState(null);
//     const [token, setToken] = useState(localStorage.getItem('access_token'));
//     const [loading, setLoading] = useState(true);

//     // Initialize auth state from localStorage
//     useEffect(() => {
//         const initializeAuth = () => {
//             const storedToken = localStorage.getItem('access_token');
//             const storedUser = localStorage.getItem('user');

//             if (storedToken && storedUser) {
//                 try {
//                     setToken(storedToken);
//                     setUser(JSON.parse(storedUser));
//                 } catch (error) {
//                     console.error('Failed to restore session:', error);
//                     logout();
//                 }
//             }
//             setLoading(false);
//         };

//         initializeAuth();
//     }, []);

//     const login = useCallback((userData, accessToken, refreshToken) => {
//         const transformedUser = transformUserData(userData);
//         setUser(transformedUser);
//         setToken(accessToken);
        
//         localStorage.setItem('access_token', accessToken);
//         localStorage.setItem('refresh_token', refreshToken);
//         localStorage.setItem('user', JSON.stringify(transformedUser));
//     }, []);

//     const logout = useCallback(async () => {
//         try {
//             const refreshToken = localStorage.getItem('refresh_token');
//             if (refreshToken) {
//                 await fetch(`${API_BASE_URL}/accounts/auth/logout/`, {
//                     method: 'POST',
//                     headers: {
//                         'Content-Type': 'application/json',
//                         'Authorization': `Bearer ${token}`
//                     },
//                     body: JSON.stringify({ refresh: refreshToken })
//                 });
//             }
//         } catch (error) {
//             console.error('Logout error:', error);
//         } finally {
//             setUser(null);
//             setToken(null);
//             localStorage.removeItem('access_token');
//             localStorage.removeItem('refresh_token');
//             localStorage.removeItem('user');
//         }
//     }, [token]);

//     const refreshAccessToken = useCallback(async () => {
//         const refreshToken = localStorage.getItem('refresh_token');
//         if (!refreshToken) return false;
        
//         try {
//             const response = await fetch(`${API_BASE_URL}/accounts/auth/refresh/`, {
//                 method: 'POST',
//                 headers: { 'Content-Type': 'application/json' },
//                 body: JSON.stringify({ refresh: refreshToken })
//             });
            
//             if (response.ok) {
//                 const data = await response.json();
//                 const newAccessToken = data.data?.access || data.access;
//                 if (newAccessToken) {
//                     setToken(newAccessToken);
//                     localStorage.setItem('access_token', newAccessToken);
//                     return true;
//                 }
//             }
//         } catch (error) {
//             console.error('Token refresh failed:', error);
//         }
        
//         return false;
//     }, []);

//     // ============================================================
//     // 🔥 UPDATED: authFetch with Subdomain Header
//     // ============================================================
//     const authFetch = useCallback(async (url, options = {}) => {
//         const makeRequest = async (currentToken) => {
//             const headers = {
//                 ...options.headers,
//             };
            
//             // 🔥 ADD SUBDOMAIN HEADER
//             const subdomain = getCurrentSubdomain();
//             if (subdomain) {
//                 headers['X-Subdomain'] = subdomain;
//                 console.log(`🟡 Adding X-Subdomain header: ${subdomain}`);
//             }
            
//             if (currentToken) {
//                 headers['Authorization'] = `Bearer ${currentToken}`;
//             }
            
//             // Handle FormData properly
//             if (!options.headers?.['Content-Type'] && options.body instanceof FormData) {
//                 delete headers['Content-Type'];
//             } else if (!options.headers?.['Content-Type'] && !(options.body instanceof FormData)) {
//                 headers['Content-Type'] = 'application/json';
//             }
            
//             // If body is an object and not FormData, stringify it
//             if (options.body && typeof options.body === 'object' && !(options.body instanceof FormData)) {
//                 options.body = JSON.stringify(options.body);
//             }
            
//             // Log request details for debugging
//             console.log(`📤 Request: ${options.method || 'GET'} ${url}`);
//             console.log(`📤 Headers:`, headers);
            
//             return fetch(`${API_BASE_URL}${url}`, { ...options, headers });
//         };
        
//         let response = await makeRequest(token);
        
//         if (response.status === 401) {
//             const refreshed = await refreshAccessToken();
//             if (refreshed) {
//                 response = await makeRequest(localStorage.getItem('access_token'));
//             } else {
//                 logout();
//                 throw new Error('Session expired');
//             }
//         }
        
//         return response;
//     }, [token, refreshAccessToken, logout]);

//     const value = {
//         API_BASE_URL,
//         user,
//         token,
//         loading,
//         login,
//         logout,
//         isAuthenticated: !!(user && token),
//         authFetch,
//         refreshAccessToken,
//         getCurrentSubdomain, // Expose for components
//         // Role-based helpers
//         isAdmin: user?.role === 'ADMIN',
//         isAgent: user?.role === 'AGENT',
//         isSubAgent: user?.role === 'SUB_AGENT',
//         isCustomer: user?.role === 'CUSTOMER',
//     };
    
//     return (
//         <AuthContext.Provider value={value}>
//             {children}
//         </AuthContext.Provider>
//     );
// };

// export const useAuth = () => {
//     const context = React.useContext(AuthContext);
//     if (context === undefined) {
//         throw new Error('useAuth must be used within an AuthProvider');
//     }
//     return context;
// };















import React, { useState, useEffect, useCallback } from 'react';
import { AuthContext, transformUserData } from '../contexts/AuthContext';

// ============================================================
// API Base URL Configuration
// ============================================================
const getApiBaseUrl = () => {
    const hostname = window.location.hostname;

    if (hostname === 'localhost' || hostname === '127.0.0.1') {
        return 'http://localhost:8000';
    }
    if (hostname === 'lvh.me' || hostname === 'www.lvh.me') {
        return 'http://lvh.me:8000';
    }
    if (hostname === 'azoemart.com' || hostname === 'www.azoemart.com') {
        return 'https://api.azoemart.com';
    }
    if (hostname.endsWith('.azoeshop.store')) {
        return 'https://api.azoemart.com';
    }
    return 'https://api.azoemart.com';
};

const getCurrentSubdomain = () => {
    const hostname = window.location.hostname;
    if (hostname.endsWith('.lvh.me')) {
        return hostname.replace('.lvh.me', '');
    }
    if (hostname.endsWith('.azoeshop.store')) {
        return hostname.replace('.azoeshop.store', '');
    }
    return null;
};

export const API_BASE_URL = getApiBaseUrl();
console.log(`🔵 API_BASE_URL: ${API_BASE_URL}`);
console.log(`🔵 Current subdomain: ${getCurrentSubdomain() || 'none'}`);

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [token, setToken] = useState(localStorage.getItem('access_token'));
    const [loading, setLoading] = useState(true);

    const [unpaidGate, setUnpaidGate] = useState({
        active: false,
        paymentUrl: null,
        message: null,
    });

    useEffect(() => {
        const initializeAuth = () => {
            const storedToken = localStorage.getItem('access_token');
            const storedUser = localStorage.getItem('user');

            if (storedToken && storedUser) {
                try {
                    setToken(storedToken);
                    setUser(JSON.parse(storedUser));
                } catch (error) {
                    console.error('Failed to restore session:', error);
                    logout();
                }
            }
            setLoading(false);
        };

        initializeAuth();
    }, []);

    const login = useCallback((userData, accessToken, refreshToken) => {
        const transformedUser = transformUserData(userData);
        setUser(transformedUser);
        setToken(accessToken);

        localStorage.setItem('access_token', accessToken);
        localStorage.setItem('refresh_token', refreshToken);
        localStorage.setItem('user', JSON.stringify(transformedUser));
    }, []);

    const logout = useCallback(async () => {
        try {
            const refreshToken = localStorage.getItem('refresh_token');
            if (refreshToken) {
                await fetch(`${API_BASE_URL}/accounts/auth/logout/`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`
                    },
                    body: JSON.stringify({ refresh: refreshToken })
                });
            }
        } catch (error) {
            console.error('Logout error:', error);
        } finally {
            setUser(null);
            setToken(null);
            localStorage.removeItem('access_token');
            localStorage.removeItem('refresh_token');
            localStorage.removeItem('user');
        }
    }, [token]);

    const refreshAccessToken = useCallback(async () => {
        const refreshToken = localStorage.getItem('refresh_token');
        if (!refreshToken) return false;

        try {
            const response = await fetch(`${API_BASE_URL}/accounts/auth/refresh/`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ refresh: refreshToken })
            });

            if (response.ok) {
                const data = await response.json();
                const newAccessToken = data.data?.access || data.access;
                if (newAccessToken) {
                    setToken(newAccessToken);
                    localStorage.setItem('access_token', newAccessToken);
                    return true;
                }
            }
        } catch (error) {
            console.error('Token refresh failed:', error);
        }

        return false;
    }, []);

    const authFetch = useCallback(async (url, options = {}) => {
        const makeRequest = async (currentToken) => {
            const headers = { ...options.headers };

            const subdomain = getCurrentSubdomain();
            if (subdomain) {
                headers['X-Subdomain'] = subdomain;
            }

            if (currentToken) {
                headers['Authorization'] = `Bearer ${currentToken}`;
            }

            if (!options.headers?.['Content-Type'] && options.body instanceof FormData) {
                delete headers['Content-Type'];
            } else if (!options.headers?.['Content-Type'] && !(options.body instanceof FormData)) {
                headers['Content-Type'] = 'application/json';
            }

            if (options.body && typeof options.body === 'object' && !(options.body instanceof FormData)) {
                options.body = JSON.stringify(options.body);
            }

            return fetch(`${API_BASE_URL}${url}`, { ...options, headers });
        };

        let response = await makeRequest(token);

        if (response.status === 401) {
            const refreshed = await refreshAccessToken();
            if (refreshed) {
                response = await makeRequest(localStorage.getItem('access_token'));
            } else {
                logout();
                throw new Error('Session expired');
            }
        }

        if (response.status === 403) {
            try {
                const cloned = response.clone();
                const peek = await cloned.json().catch(() => null);
                if (peek && peek.code === 'REGISTRATION_PAYMENT_REQUIRED') {
                    setUnpaidGate({
                        active: true,
                        paymentUrl: peek.payment_url || '/accounts/registration/initiate-payment/',
                        message: peek.message || 'Registration fee not paid.',
                    });
                }
            } catch {}
        }

        return response;
    }, [token, refreshAccessToken, logout]);

    const refreshUser = useCallback(async () => {
        try {
            const res = await authFetch('/accounts/user/me/');
            const data = await res.json();
            if (res.ok && data.status === 'success' && data.data) {
                const transformed = transformUserData(data.data);
                setUser(transformed);
                localStorage.setItem('user', JSON.stringify(transformed));
                if (!transformed.is_unpaid_agent) {
                    setUnpaidGate({ active: false, paymentUrl: null, message: null });
                }
                return transformed;
            }
        } catch (e) {
            console.error('refreshUser failed:', e);
        }
        return null;
    }, [authFetch]);

    const becomeAgent = useCallback(async (payload) => {
        try {
            const res = await authFetch('/accounts/become-agent/', {
                method: 'POST',
                body: JSON.stringify(payload),
            });
            const data = await res.json();
            if (!res.ok || data.status !== 'success') {
                return {
                    ok: false,
                    error: data.message || 'Could not upgrade account.',
                    errors: data.errors || null,
                };
            }
            return { ok: true, data: data.data };
        } catch (e) {
            return { ok: false, error: 'Network error. Please try again.' };
        }
    }, [authFetch]);

    // ============================================================
    // initiateRegistrationPayment
    //
    // - Authenticated (default): sends via authFetch with Bearer token.
    // - Public ({ userId }): sends unauthenticated with { user_id } body.
    //   Used by the /activate-registration page when there are no tokens.
    // ============================================================
    const initiateRegistrationPayment = useCallback(async (opts = {}) => {
        const { userId } = opts;

        // Public path — no token, body carries user_id
        if (userId) {
            try {
                const res = await fetch(
                    `${API_BASE_URL}/accounts/registration/initiate-payment/`,
                    {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({ user_id: userId }),
                    }
                );
                const data = await res.json();

                if (res.status === 429) {
                    return {
                        ok: false,
                        throttled: true,
                        error:
                            data.message ||
                            'Too many attempts. Please wait a minute and try again.',
                    };
                }
                if (!res.ok || data.status !== 'success') {
                    return {
                        ok: false,
                        error: data.message || 'Could not initiate payment.',
                        detail: data.detail || null,
                    };
                }
                return { ok: true, data: data.data };
            } catch (e) {
                return { ok: false, error: 'Network error. Please try again.' };
            }
        }

        // Authenticated path
        try {
            const res = await authFetch('/accounts/registration/initiate-payment/', {
                method: 'POST',
            });
            const data = await res.json();
            if (!res.ok || data.status !== 'success') {
                return {
                    ok: false,
                    error: data.message || 'Could not initiate payment.',
                    detail: data.detail || null,
                };
            }
            return { ok: true, data: data.data };
        } catch (e) {
            return { ok: false, error: 'Network error. Please try again.' };
        }
    }, [authFetch]);

    // ============================================================
    // pollRegistrationStatus — also used by the activate page, which
    // has no token yet, so we call the endpoint without Authorization.
    // ============================================================
    const pollRegistrationStatus = useCallback(async (userId, { intervalMs = 3500, maxAttempts = 34 } = {}) => {
        const targetId = userId || user?.id;
        if (!targetId) return { ok: false, error: 'No user id.' };

        for (let attempt = 0; attempt < maxAttempts; attempt++) {
            try {
                const res = await fetch(
                    `${API_BASE_URL}/accounts/registration/status/?user_id=${targetId}`
                );
                const data = await res.json();
                if (res.ok && data.status === 'success' && data.is_complete) {
                    if (data.data?.tokens?.access) {
                        const access = data.data.tokens.access;
                        const refresh = data.data.tokens.refresh;
                        setToken(access);
                        localStorage.setItem('access_token', access);
                        if (refresh) localStorage.setItem('refresh_token', refresh);
                    }
                    await refreshUser();
                    return { ok: true, data: data.data };
                }
            } catch (e) {
                // keep polling
            }
            await new Promise(r => setTimeout(r, intervalMs));
        }
        return { ok: false, error: 'Timed out waiting for payment confirmation.' };
    }, [user?.id, refreshUser]);

    const clearUnpaidGate = useCallback(() => {
        setUnpaidGate({ active: false, paymentUrl: null, message: null });
    }, []);

    const value = {
        API_BASE_URL,
        user,
        token,
        loading,
        login,
        logout,
        isAuthenticated: !!(user && token),
        authFetch,
        refreshAccessToken,
        getCurrentSubdomain,
        isAdmin: user?.role === 'ADMIN',
        isAgent: user?.role === 'AGENT',
        isSubAgent: user?.role === 'SUB_AGENT',
        isCustomer: user?.role === 'CUSTOMER',

        isUnpaidAgent: !!user?.is_unpaid_agent,
        isFullyRegisteredAgent: !!user?.is_fully_registered_agent,
        unpaidGate,
        clearUnpaidGate,
        refreshUser,
        becomeAgent,
        initiateRegistrationPayment,
        pollRegistrationStatus,
    };

    return (
        <AuthContext.Provider value={value}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => {
    const context = React.useContext(AuthContext);
    if (context === undefined) {
        throw new Error('useAuth must be used within an AuthProvider');
    }
    return context;
};